<template>
  <div v-if="!isOutOfSync" class="text-center text-subtitle-2" style="font-size: 16px">
    Datos desactualizados (se recomienda consultar nuevamente)
  </div>
</template>

<script>
function sortObjectDeep(value) {
  if (value === null || value === undefined) return value
  if (Array.isArray(value)) return value.map(sortObjectDeep)
  if (typeof value === "object") {
    const keys = Object.keys(value).sort()
    const out = {}
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      out[k] = sortObjectDeep(value[k])
    }
    return out
  }
  return value
}

function deepEqual(a, b) {
  if (a === b) return true
  if (typeof a !== typeof b) return false
  if (a === null || b === null) return a === b
  if (typeof a !== "object") return a === b

  if (Array.isArray(a)) {
    if (!Array.isArray(b) || a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i])) return false
    }
    return true
  }

  const ak = Object.keys(a)
  const bk = Object.keys(b)
  if (ak.length !== bk.length) return false
  for (let i = 0; i < ak.length; i++) {
    const k = ak[i]
    if (!Object.prototype.hasOwnProperty.call(b, k)) return false
    if (!deepEqual(a[k], b[k])) return false
  }
  return true
}

export default {
  props: {
    expectedFilters: { type: Object, default: () => ({}) }, // filtros “buscados”
    appliedFilters: { type: Object, default: () => ({}) },  // filtros “aplicados”
  },
  computed: {
    isOutOfSync() {
      const a = sortObjectDeep(this.expectedFilters)
      const b = sortObjectDeep(this.appliedFilters)
      // si son iguales -> mostrar "Filtros desfazados"
      return deepEqual(a, b)
    },
  },
}
</script>
